import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__info">
          <span>© {new Date().getFullYear()} Language Hero</span>
          <a href="tel:+17868198806"><i className="bi bi-telephone" /> (786) 819-8806</a>
          <a href="mailto:admin@languageherollc.com"><i className="bi bi-envelope" /> admin@languageherollc.com</a>
        </div>
        <div className="site-footer__social">
          <a href="https://www.instagram.com/languagehero.llc/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="bi bi-instagram" /></a>
          <a href="https://www.linkedin.com/in/mariana-g-tarifa-29134b116/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="bi bi-linkedin" /></a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
